import React from "react";
import { Footer } from "../footer/Footer";
import { Navbar } from "../navbar/Navbar";

const LayoutBase: React.FC = ({ children }) => {
  return (
    <>
      <Navbar />
      <div className="container-fluid content-page">{children}</div>
      <Footer />
    </>
  );
};

export default LayoutBase;
